import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UiButtonComponent } from './ui-button.component';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@lenovo/material/tooltip';
@NgModule({
	declarations: [
		UiButtonComponent
	],
	exports: [
		UiButtonComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		MatTooltipModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA
	]
})
export class UiButtonModule { }
